import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { LiquidationAttributes } from '../../interfaces/liquidation.interface';

/**
 * Liquidation Date Cell Renderer
 *
 * Displays liquidation creation date in Spanish format: dd/MM/yyyy HH:mm
 */
@Component({
  selector: 'app-liquidation-date-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span class="text-sm">{{ formattedDate }}</span>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LiquidationDateCellRendererComponent implements CellRenderer<LiquidationAttributes, string> {
  @Input() params!: CellRendererParams<LiquidationAttributes, string>;

  get formattedDate(): string {
    const dateValue = this.params?.value || this.params?.data?.createdAt;
    if (!dateValue) return '-';

    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return '-';

    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
}
